/**
 * Real-Time 3D Chrome Metallic WebGL Renderer for Gothic W Logo
 * Extrudes SVG Vector Paths into Physical 3D Chrome Metal Objects
 */
(function() {
  if (window.MetalLogo3DInitialized) return;
  window.MetalLogo3DInitialized = true;

  // Load Three.js dynamically if not present
  function loadThreeJS(callback) {
    if (window.THREE) {
      callback();
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
    script.onload = callback;
    document.head.appendChild(script);
  }

  function initWebGLCanvas(container) {
    if (container.dataset.initialized) return;
    container.dataset.initialized = "true";

    const width = container.clientWidth || 180;
    const height = container.clientHeight || 180;

    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(40, width / height, 0.1, 1000);
    camera.position.set(0, 0, 220);

    const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setSize(width, height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.shadowMap.enabled = true;
    container.appendChild(renderer.domElement);

    // Pure Studio Chrome Lighting System
    const ambientLight = new THREE.AmbientLight(0xffffff, 1.2);
    scene.add(ambientLight);

    const keyLight = new THREE.DirectionalLight(0xffffff, 4.0);
    keyLight.position.set(100, 150, 200);
    scene.add(keyLight);

    const fillLight = new THREE.DirectionalLight(0xeeeeee, 1.5);
    fillLight.position.set(-150, 50, -100);
    scene.add(fillLight);

    const rimLight = new THREE.PointLight(0xffffff, 4.0, 300);
    rimLight.position.set(0, 100, -150);
    scene.add(rimLight);

    // Gothic "W" Logo Vector Path (Parsed directly for instant 3D rendering)
    const svgPathD = "M 245.5 95 L 274.5 96 L 290.5 100 L 300.5 104 L 311.5 111 L 321 120.5 L 331 134.5 L 344 169.5 L 353 209.5 L 354 235.5 L 356 245 L 361.5 242 L 398 205.5 L 398 107.5 L 398.5 107 L 421.5 107 L 423 108.5 L 423 170.5 L 424.5 179 L 509.5 95 Q 527.4 107.6 541 124.5 L 552 140.5 L 561 158.5 L 569 181.5 L 571 195.5 L 573 200.5 L 573.5 248 L 616 205.5 L 616 107 L 641 107 L 641 179.5 L 722.5 99 L 726.5 96 L 729.5 96 L 802.5 171 Q 825.5 145.5 852.5 124 L 869 141.5 L 790 220.5 L 790 552.5 L 791 553.5 L 791 663 Q 797 665 807.5 664 L 811.5 666 L 824.5 668 L 834 672 L 835 674.5 L 832 681.5 L 831 688.5 L 826.5 696 L 810.5 693 L 788.5 692 L 782.5 690 L 757.5 690 L 751.5 692 L 723.5 694 L 714.5 697 L 709.5 697 L 679.5 705 Q 673.5 709.5 664.5 711 L 618.5 734 L 578.5 762 L 565.5 774 L 561.5 775 L 504.5 719 L 489.5 705 L 485.5 703 L 400.5 764 L 394.5 767 L 386.5 774 L 381.5 776 L 354.5 755 L 320.5 739 L 306.5 735 L 287.5 733 L 280.5 731 L 248.5 731 L 235.5 734 L 223.5 735 L 194.5 745 L 169.5 760 L 147 780.5 Q 136.2 792.2 130 808.5 L 123 833.5 L 123 848.5 L 124 849.5 L 125 871.5 L 132 891.5 L 140 905.5 L 159.5 925 L 183.5 940 L 206.5 950 Q 216.1 950.4 222.5 954 L 242.5 956 L 249 958 L 249 979.5 L 247.5 981 L 237.5 981 L 220.5 977 L 209.5 976 L 178.5 966 Q 159.4 957.6 143.5 946 L 124 927.5 L 113 912.5 L 106 898.5 L 106 895.5 L 104 893.5 L 100 881.5 L 96 864.5 L 95 829.5 L 96 828.5 L 97 810.5 Q 100 806.5 100 799.5 L 109 774.5 L 116 760.5 Q 132.8 729.3 158.5 707 L 190.5 687 L 203.5 682 L 206.5 682 L 211.5 679 L 231.5 674 L 238.5 671 L 247.5 670 L 266.5 665 L 278 664 L 278 612.5 L 279 611.5 L 279 468.5 L 278 467.5 L 278 457 Q 269.3 449.5 253.5 448 L 245.5 450 L 232 458 Q 224.7 467.8 220 481.5 Q 217.2 490.2 219 503.5 L 223 515.5 L 223 521 L 216.5 522 L 213.5 524 L 200 526 L 200 522.5 L 193 502.5 L 192 492.5 L 190 488.5 L 189 450.5 L 190 449.5 L 190 438.5 Q 193.6 433.1 194 424.5 Q 200 409 212.5 400 L 221.5 393 L 239.5 386 L 257.5 382 L 276.5 381 L 278 379.5 L 278 234.5 L 276 230.5 L 274 218.5 L 262 198 L 255.5 193 L 241.5 186 L 236.5 185 L 210.5 185 Q 186.9 190.4 174 206.5 L 160 230.5 L 152 251.5 L 149 264.5 L 147.5 266 L 145.5 267 L 128 267 L 130 251.5 L 132 247.5 L 133 238.5 Q 137.4 230.9 138 219.5 L 140 216.5 L 141 209.5 L 155 170.5 L 175 131.5 L 192.5 113 L 207.5 104 L 226.5 97 L 244.5 96 L 245.5 95 Z";

    // Inner cutout paths
    const cutoutDs = [
      "M 682 174 L 641 215 L 641 350 L 666 357 L 690 357 Q 691 355 697 356 L 715 349 L 715 208 L 689 181 L 682 174 Z",
      "M 462 178 L 454 185 L 423 216 L 423 350 Q 428 353 438 354 L 440 356 L 479 356 L 495 350 L 495 231 L 490 214 L 484 202 L 475 189 L 462 178 Z",
      "M 615 242 L 606 250 L 573 283 L 573 665 L 615 705 L 615 675 L 616 674 L 616 265 L 615 264 L 615 242 Z",
      "M 397 243 L 356 283 L 356 648 L 357 649 L 357 664 L 370 667 L 397 677 L 397 650 L 398 649 L 398 265 L 397 264 L 397 243 Z",
      "M 423 376 L 423 496 L 437 492 Q 443 494 445 491 L 475 491 L 486 493 L 490 495 L 495 495 L 495 488 L 496 487 L 496 385 L 495 384 L 495 376 L 486 379 L 475 379 L 474 380 L 445 380 L 423 376 Z",
      "M 641 376 L 641 496 L 650 493 L 663 492 L 664 491 L 693 491 L 714 495 L 714 488 L 715 487 L 715 376 L 695 380 L 692 382 L 677 382 L 673 380 L 666 380 L 665 379 L 659 379 L 641 376 Z",
      "M 451 513 L 450 514 L 437 515 L 426 520 L 423 521 L 423 690 L 442 704 L 496 663 L 496 531 L 495 530 L 495 520 L 478 514 L 451 513 Z",
      "M 662 515 L 659 517 L 651 518 L 641 521 L 642 694 L 680 678 L 714 669 L 714 660 L 715 659 L 715 521 L 697 517 L 694 515 L 662 515 Z"
    ];

    // Helper: Simple SVG Path to Three.js Shape converter
    function parseSvgPathToShape(d) {
      const shape = new THREE.Shape();
      const commands = d.match(/([a-df-z])([^a-df-z]*)/gi);
      let currX = 0, currY = 0;

      if (!commands) return shape;

      commands.forEach(cmdStr => {
        const type = cmdStr[0];
        const args = cmdStr.slice(1).trim().split(/[\s,]+/).filter(Boolean).map(Number);

        if (type === 'M') {
          currX = args[0];
          currY = args[1];
          shape.moveTo(currX, -currY);
        } else if (type === 'L') {
          for (let i = 0; i < args.length; i += 2) {
            currX = args[i];
            currY = args[i+1];
            shape.lineTo(currX, -currY);
          }
        } else if (type === 'Q') {
          for (let i = 0; i < args.length; i += 4) {
            shape.quadraticCurveTo(args[i], -args[i+1], args[i+2], -args[i+3]);
            currX = args[i+2];
            currY = args[i+3];
          }
        } else if (type === 'Z' || type === 'z') {
          shape.closePath();
        }
      });

      return shape;
    }

    const outerShape = parseSvgPathToShape(svgPathD);
    cutoutDs.forEach(holeD => {
      const holeShape = parseSvgPathToShape(holeD);
      outerShape.holes.push(holeShape);
    });

    // Physical 3D Extrusion
    const extrudeSettings = {
      depth: 65,
      bevelEnabled: true,
      bevelSegments: 8,
      steps: 4,
      bevelSize: 5,
      bevelThickness: 6
    };

    const geometry = new THREE.ExtrudeGeometry(outerShape, extrudeSettings);
    geometry.center();

    // Liquid Chrome Metal Physical Material (Brighter Silver Chrome)
    const chromeMaterial = new THREE.MeshStandardMaterial({
      color: 0xffffff,
      metalness: 0.95,
      roughness: 0.12,
      shadowSide: THREE.DoubleSide
    });

    const logoMesh = new THREE.Mesh(geometry, chromeMaterial);
    
    // Scale & Position (Straight Facing - No Tilt)
    logoMesh.scale.set(0.115, 0.115, 0.115);
    logoMesh.rotation.x = 0; // Facing straight with no tilt
    scene.add(logoMesh);

    // Animation Loop (Slow, elegant luxury rotation)
    function animate() {
      requestAnimationFrame(animate);
      logoMesh.rotation.y += 0.009; // Smooth 360-degree rotation on Y-axis
      renderer.render(scene, camera);
    }
    animate();
  }

  function initAllContainers() {
    loadThreeJS(function() {
      document.querySelectorAll('.metal-w-threejs-container').forEach(initWebGLCanvas);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllContainers);
  } else {
    initAllContainers();
  }

  // Support Shopify dynamic section reloads
  document.addEventListener('shopify:section:load', initAllContainers);
})();
